import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UXPContext } from "@core/context/Context";
import { useEffect, useContext, useRef, useState } from "react";
import DashboardEditOverlay from "./DashboardEditOverlay";
import { hasConfigOptions, isDraggable, SPACER_WIDGET_ID, PLACEHOLDER_WIDGET_ID } from "../dashboardUtils";
import { hasValue } from "@utils";
import { WIDGET_PANEL_ID } from "../dashboardUtils";
import { FontAwesomeIconWrapper } from "@icon/fontawesome/FontAwesomeIconWrapper";
import ComponentRenderer from "@helper/ComponentRenderer/ComponentRenderer";
import classNames from "classnames";
const DashboardWidget = ({ widget, onPropsChange, isEditing, onSync, onRemove, onDuplicate, onConfigure, onLock, onAddonInstalled, onPlaceholderClick }) => {
    var _a, _b, _c;
    const context = useContext(UXPContext);
    const isContainerWidget = widget.id === WIDGET_PANEL_ID;
    const containerOpenDrawerRef = useRef(null);
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const widgetContainerRef = useRef(null);
    useEffect(() => {
        const el = widgetContainerRef.current;
        if (!el)
            return;
        const observer = new ResizeObserver((entries) => {
            const entry = entries[0];
            if (!entry)
                return;
            const { width, height } = entry.contentRect;
            setDimensions({ width: Math.round(width), height: Math.round(height) });
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);
    // Handle spacer widget (empty space at bottom)
    if (widget.id === SPACER_WIDGET_ID) {
        return _jsx("div", { className: classNames("uxpcore_dashboard__spacer", { 'uxpcore_dashboard__spacer--edit': isEditing }) });
    }
    // Handle placeholder widget (empty dashboard with "add widgets" prompt)
    if (widget.id === PLACEHOLDER_WIDGET_ID) {
        const config = widget.configuredProps || {};
        if ((_a = config === null || config === void 0 ? void 0 : config.message) === null || _a === void 0 ? void 0 : _a.enable) {
            return _jsx("div", { className: "uxpcore_dashboard__placeholder uxpcore_dashboard__placeholder--message", children: _jsx("div", { className: "uxpcore_dashboard__placeholder-message-container", children: hasValue((_b = config === null || config === void 0 ? void 0 : config.message) === null || _b === void 0 ? void 0 : _b.content)
                        ? config.message.content
                        : context.$L('uxp-core.text.add-widgets-to-get-started') }) });
        }
        return _jsx("div", { className: "uxpcore_dashboard__placeholder", onClick: () => { if (onPlaceholderClick)
                onPlaceholderClick(); }, style: { cursor: onPlaceholderClick ? 'pointer' : 'default' }, children: _jsx("div", { className: "uxpcore_dashboard__placeholder-icon-container", children: _jsx("div", { className: "uxpcore_dashboard__placeholder-icon", children: _jsx(FontAwesomeIconWrapper, { icon: ['fal', 'plus'] }) }) }) });
    }
    // Determine edit overlay options
    const showConfigOption = hasConfigOptions(widget);
    const showDragHandler = isDraggable(widget);
    return _jsxs("div", { ref: widgetContainerRef, style: { width: '100%', height: '100%', position: 'relative' }, children: [_jsx(ComponentRenderer, { componentInstance: widget, onConfigureRequest: () => onConfigure(widget), onAddonInstalled: onAddonInstalled, additionalProps: Object.assign({ instanceId: widget._id, onWidgetPropsChange: onPropsChange, isEditing, __width__: dimensions.width, __height__: dimensions.height }, (isContainerWidget ? {
                    onRegisterOpenDrawer: (fn) => { containerOpenDrawerRef.current = fn; }
                } : {})) }), isEditing && (_jsx(DashboardEditOverlay, { widget: widget, showConfigOption: showConfigOption, showDragHandler: showDragHandler, isLocked: ((_c = widget.layout) === null || _c === void 0 ? void 0 : _c.isDraggable) === false, onSync: onSync, onRemove: onRemove, onDuplicate: onDuplicate, onConfigure: onConfigure, onLock: onLock, allowClickThrough: isContainerWidget, isContainerWidget: isContainerWidget, extraActions: isContainerWidget ? [{
                        icon: 'fal plus',
                        onClick: () => { var _a; return (_a = containerOpenDrawerRef.current) === null || _a === void 0 ? void 0 : _a.call(containerOpenDrawerRef); },
                        title: context.$L('uxp-core.text.add-widget')
                    }] : [] }))] });
};
export default DashboardWidget;
